import React, { useEffect } from "react";
import Project from "../components/Project/Project";

const ProjectsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Project />
    </>
  );
};

export default ProjectsPage;
